export function createInspectionRepository(config) {
    const { repository, client: api } = config;
    const PREFIX = ['conversations', 'inspections'];
    return {
        useLookup(context, props, options) {
            const query = repository.useQuery({
                staleTime: Infinity,
                ...options,
                queryKey: [...PREFIX, props],
                async queryFn() {
                    const response = await api.inspectionCreate({
                        threadCreatePayload: props,
                    }, {
                        headers: {
                            Authorization: `Bearer ${context.token}`,
                        },
                    });
                    return response.data;
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=assistantInspectionRepository.js.map